function toTrimmedString(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function splitLeadContactName(contactName) {
  const normalized = toTrimmedString(contactName);
  if (!normalized) {
    return { first_name: "Unbekannt", last_name: "Kontakt" };
  }

  const parts = normalized.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return { first_name: parts[0], last_name: "Kontakt" };
  }

  return {
    first_name: parts[0],
    last_name: parts.slice(1).join(" "),
  };
}

export function buildCompanyPayloadFromLead(lead) {
  return {
    name: toTrimmedString(lead?.company_name),
    website: "",
    industry: "",
    size: "",
    address: "",
    source: "",
    notes: "",
  };
}

export function buildContactPayloadFromLead(lead, publicSubmission = null) {
  const { first_name, last_name } = splitLeadContactName(lead?.contact_name);
  const payload = {
    first_name,
    last_name,
    email: toTrimmedString(lead?.contact_email),
    phone: toTrimmedString(lead?.contact_phone),
    position: "",
    linkedin_url: "",
    notes: "",
    consent_marketing: false,
  };

  if (publicSubmission?.marketing_consent) {
    payload.consent_marketing = true;
    if (publicSubmission?.marketing_consent_at) {
      payload.consent_marketing_at = publicSubmission.marketing_consent_at;
    }
    payload.consent_marketing_source = "public_form";
    if (publicSubmission?.marketing_consent_text_snapshot) {
      payload.consent_marketing_text_snapshot =
        publicSubmission.marketing_consent_text_snapshot;
    }
  }

  if (lead?.company_id) {
    payload.company_id = lead.company_id;
  }

  return payload;
}

export function canCreateCompanyFromLead(lead) {
  return Boolean(toTrimmedString(lead?.company_name)) && !lead?.company_id;
}

export function canCreateContactFromLead(lead) {
  return !lead?.contact_id && Boolean(toTrimmedString(lead?.contact_name) || toTrimmedString(lead?.contact_email));
}
